import React from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom";

const { Footer: AntFooter } = Layout;

/**
 * Modern polished footer
 * - Light gray background with subtle top border
 * - Two-column layout: left (branding text), right (links)
 * - Hover transitions for links
 * - Responsive: stacks vertically on mobile
 */

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <>
      <style>{`
        .lp-footer {
          background: #fafafa;
          border-top: 1px solid #eaeaea;
          padding: 32px 20px;
          font-size: 15px;
          color: #555;
        }

        .footer-inner {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .footer-brand {
          font-weight: 500;
          color: #333;
        }

        .footer-links {
          display: flex;
          gap: 20px;
        }

        .footer-links a {
          color: #555;
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .footer-links a:hover {
          color: #0b5cff;
        }

        @media (max-width: 768px) {
          .footer-inner {
            flex-direction: column;
            text-align: center;
          }
          .footer-links {
            justify-content: center;
          }
        }
      `}</style>

      <AntFooter className="lp-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            PSG Alumni Connect © {year} • All Rights Reserved
          </div>

          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
          </div>
        </div>
      </AntFooter>
    </>
  );
}
